<template>
  <div class="form-complete-area">
    <div class="form-complete-area__title">先行アカウント登録が完了しました。</div>
    <div class="form-complete-area__lead">
      アカウント登録ありがとうございます。<br><br>
      楽曲の登録開始は12月8日からスタートとなります。<br><br>
      しばらくお待ち下さい。<br>
    </div>
    <div class="c-btn-wrap">
      <button
        class="c-btn c-btn--back"
        @click="onTopButtonClicked">
        トップへ戻る
        <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComingSoon',
  methods: {
    onTopButtonClicked() {
      window.location.href = this.appUrl
    },
  },
}
</script>

<style scoped>
.form-complete-area {
  width: 100%!important;
}
.form-complete-area__lead {
  margin: 50px auto;
}
</style>
